<div
  class="bet-header-container"
  [ngClass]="{
    'flex justify-between space-x-4': !isThreeElement,
    'grid grid-cols-7 place-items-center gap-1': isThreeElement
  }"
>
  <div class="deal-no" [class.!w-[50%]]="!isThreeElement">
    TABLE: {{ _classicService.activeTable.name }}
  </div>

  <div class="auto-bet-toggle flex items-center" *ngIf="showAutoBettingToggle">
    <label class="inline-flex cursor-pointer items-center">
      <input
        type="checkbox"
        [(ngModel)]="_autoBettingService.enableAutoBetting"
        (change)="toggleAutoBetting()"
        class="peer sr-only"
        [ngModelOptions]="{ standalone: true }"
      />
      <div
        class="popup-transition peer relative h-4 w-7 rounded-full bg-white after:absolute after:start-[2px] after:top-0.5 after:h-3 after:w-3 after:rounded-full after:border after:border-gray-600 after:bg-gray-500 after:transition-all after:content-[''] peer-checked:bg-green-500 peer-checked:after:translate-x-full peer-checked:after:border-white peer-focus:ring-1 peer-focus:ring-green-500 rtl:peer-checked:after:-translate-x-full dark:border-white dark:bg-white dark:peer-focus:ring-green-500"
      ></div>

      <span class="ml-3 text-xs">Auto Bet</span>
    </label>
  </div>
  <button
    id="btnBettingBack"
    class="btn-secondary-v3 flex flex-row items-center justify-center p-[0.5rem] text-xs"
    (click)="back()"
    [class.hide]="!showGameComponent || _playerService.currentSeat"
  >
    Back
    <fa-icon icon="arrow-right" class="ml-2"></fa-icon>
  </button>
</div>
